import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider, ColorModeScript, extendTheme, Box, IconButton, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import { FaUniversalAccess, FaPlus, FaMinus, FaUnderline, FaFont } from 'react-icons/fa';

// --- WIDGET D'ACCESSIBILITÉ PREMIUM 100% REACT (SÉCURISÉ & GRATUIT) ---
const ProAccessibilityWidget = () => {
  const [fontSize, setFontSize] = useState(100);

  // Injection des styles pour l'accessibilité
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .highlight-links-mode a {
        text-decoration: underline !important;
        text-decoration-color: #ecc94b !important;
        text-decoration-thickness: 3px !important;
        font-weight: 900 !important;
      }
      .dyslexic-mode * {
        font-family: 'Comic Sans MS', 'OpenDyslexic', sans-serif !important;
        letter-spacing: 0.1em !important;
        word-spacing: 0.2em !important;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const adjustSize = (amount) => {
    // Limite l'agrandissement entre 80% et 150% pour ne pas casser le design du site
    const newSize = Math.min(Math.max(fontSize + amount, 80), 150);
    setFontSize(newSize);
    document.documentElement.style.fontSize = `${newSize}%`;
  };

  return (
    <Box position="fixed" bottom="30px" left="30px" zIndex="2147483647">
      <Menu placement="top-start">
        <MenuButton
          as={IconButton}
          icon={<FaUniversalAccess size={30} />}
          bg="blue.600"
          color="white"
          w="65px"
          h="65px"
          isRound
          shadow="dark-lg"
          _hover={{ bg: 'blue.700', transform: 'scale(1.05)' }}
          _active={{ transform: 'scale(0.95)' }}
          transition="all 0.2s"
          aria-label="Menu d'accessibilité"
        />
        <MenuList p={3} shadow="2xl" borderRadius="2xl" border="1px solid #e2e8f0" mb={4}>
          <MenuItem icon={<FaPlus size={16}/>} onClick={() => adjustSize(10)} rounded="xl" mb={1} py={3} fontWeight="bold" _hover={{ bg: 'blue.50', color: 'blue.600' }}>
            Agrandir le texte
          </MenuItem>
          <MenuItem icon={<FaMinus size={16}/>} onClick={() => adjustSize(-10)} rounded="xl" mb={1} py={3} fontWeight="bold" _hover={{ bg: 'blue.50', color: 'blue.600' }}>
            Réduire le texte
          </MenuItem>
          <MenuItem icon={<FaUnderline size={16}/>} onClick={() => document.body.classList.toggle('highlight-links-mode')} rounded="xl" mb={1} py={3} fontWeight="bold" _hover={{ bg: 'blue.50', color: 'blue.600' }}>
            Souligner les liens
          </MenuItem>
          <MenuItem icon={<FaFont size={16}/>} onClick={() => document.body.classList.toggle('dyslexic-mode')} rounded="xl" py={3} fontWeight="bold" _hover={{ bg: 'blue.50', color: 'blue.600' }}>
            Police lisible (Dyslexie)
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};

// Création d'un thème basique direct pour éviter tout plantage
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme}>
      
      {/* Ton widget sécurisé est appelé ici */}
      <ProAccessibilityWidget />
      
      <App />
    </ChakraProvider>
  </React.StrictMode>
);